/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as SignupRouteImport } from "./routes/signup"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as FilesIndexRouteImport } from "./routes/files/index"
import { Route as AdminIndexRouteImport } from "./routes/admin/index"
import { Route as ShareTokenRouteImport } from "./routes/share/$token"
import { Route as FilesWebhooksRouteImport } from "./routes/files/webhooks"
import { Route as FilesSyncsRouteImport } from "./routes/files/syncs"
import { Route as FilesSharesRouteImport } from "./routes/files/shares"
import { Route as FilesKeysRouteImport } from "./routes/files/keys"
import { Route as FilesFederatedBucketsRouteImport } from "./routes/files/federated-buckets"
import { Route as FilesBackupsRouteImport } from "./routes/files/backups"
import { Route as FilesRegionIdRouteImport } from "./routes/files/$regionId"
import { Route as AdminUsersRouteImport } from "./routes/admin/users"
import { Route as AdminUsageRouteImport } from "./routes/admin/usage"
import { Route as AdminSystemRouteImport } from "./routes/admin/system"
import { Route as AdminServiceAccountsRouteImport } from "./routes/admin/service-accounts"
import { Route as AdminPoliciesRouteImport } from "./routes/admin/policies"
import { Route as AdminMigrateRouteImport } from "./routes/admin/migrate"
import { Route as AdminLoginRouteImport } from "./routes/admin/login"
import { Route as AdminFirstRunRouteImport } from "./routes/admin/first-run"
import { Route as AdminAuditRouteImport } from "./routes/admin/audit"
import { Route as FilesWebhooksIndexRouteImport } from "./routes/files/webhooks/index"
import { Route as FilesSyncsIndexRouteImport } from "./routes/files/syncs/index"
import { Route as FilesSharesIndexRouteImport } from "./routes/files/shares/index"
import { Route as FilesKeysIndexRouteImport } from "./routes/files/keys/index"
import { Route as FilesFederatedBucketsIndexRouteImport } from "./routes/files/federated-buckets/index"
import { Route as FilesBackupsIndexRouteImport } from "./routes/files/backups/index"
import { Route as FilesRegionIdIndexRouteImport } from "./routes/files/$regionId/index"
import { Route as AdminUsersIndexRouteImport } from "./routes/admin/users/index"
import { Route as AdminServiceAccountsIndexRouteImport } from "./routes/admin/service-accounts/index"
import { Route as AdminClustersIndexRouteImport } from "./routes/admin/clusters/index"
import { Route as AdminBucketsIndexRouteImport } from "./routes/admin/buckets/index"
import { Route as FilesWebhooksNewRouteImport } from "./routes/files/webhooks/new"
import { Route as FilesSyncsNewRouteImport } from "./routes/files/syncs/new"
import { Route as FilesSharesNewRouteImport } from "./routes/files/shares/new"
import { Route as FilesRegionsNewRouteImport } from "./routes/files/regions/new"
import { Route as FilesKeysNewRouteImport } from "./routes/files/keys/new"
import { Route as FilesFederatedBucketsNewRouteImport } from "./routes/files/federated-buckets/new"
import { Route as FilesBackupsNewRouteImport } from "./routes/files/backups/new"
import { Route as AdminUsersNewRouteImport } from "./routes/admin/users/new"
import { Route as AdminServiceAccountsNewRouteImport } from "./routes/admin/service-accounts/new"
import { Route as AdminServiceAccountsIdRouteImport } from "./routes/admin/service-accounts/$id"
import { Route as AdminClustersNewRouteImport } from "./routes/admin/clusters/new"
import { Route as FilesWebhooksIdIndexRouteImport } from "./routes/files/webhooks/$id/index"
import { Route as FilesFederatedBucketsIdIndexRouteImport } from "./routes/files/federated-buckets/$id/index"
import { Route as FilesBackupsIdIndexRouteImport } from "./routes/files/backups/$id/index"
import { Route as AdminClustersCidIndexRouteImport } from "./routes/admin/clusters/$cid/index"
import { Route as FilesBackupsIdRestoreRouteImport } from "./routes/files/backups/$id/restore"
import { Route as FilesRegionIdBBidRouteImport } from "./routes/files/$regionId/b/$bid"
import { Route as AdminClustersCidScrubRouteImport } from "./routes/admin/clusters/$cid/scrub"
import { Route as AdminClustersCidLayoutRouteImport } from "./routes/admin/clusters/$cid/layout"
import { Route as AdminClustersCidEditRouteImport } from "./routes/admin/clusters/$cid/edit"
import { Route as AdminClustersCidKeysIdRouteImport } from "./routes/admin/clusters/$cid/keys/$id"
import { Route as AdminClustersCidBucketsIdRouteImport } from "./routes/admin/clusters/$cid/buckets/$id"
import { Route as AdminClustersCidBucketsIdLifecycleNewRouteImport } from "./routes/admin/clusters/$cid/buckets/$id/lifecycle/new"
import { Route as AdminClustersCidBucketsIdLifecycleRuleIdEditRouteImport } from "./routes/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit"

const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesIndexRoute = FilesIndexRouteImport.update({
  id: "/files/",
  path: "/files/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/admin/",
  path: "/admin/",
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: "/share/$token",
  path: "/share/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesWebhooksRoute = FilesWebhooksRouteImport.update({
  id: "/files/webhooks",
  path: "/files/webhooks",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesSyncsRoute = FilesSyncsRouteImport.update({
  id: "/files/syncs",
  path: "/files/syncs",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesSharesRoute = FilesSharesRouteImport.update({
  id: "/files/shares",
  path: "/files/shares",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesKeysRoute = FilesKeysRouteImport.update({
  id: "/files/keys",
  path: "/files/keys",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesFederatedBucketsRoute = FilesFederatedBucketsRouteImport.update({
  id: "/files/federated-buckets",
  path: "/files/federated-buckets",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesBackupsRoute = FilesBackupsRouteImport.update({
  id: "/files/backups",
  path: "/files/backups",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesRegionIdRoute = FilesRegionIdRouteImport.update({
  id: "/files/$regionId",
  path: "/files/$regionId",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: "/admin/users",
  path: "/admin/users",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: "/admin/usage",
  path: "/admin/usage",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSystemRoute = AdminSystemRouteImport.update({
  id: "/admin/system",
  path: "/admin/system",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminServiceAccountsRoute = AdminServiceAccountsRouteImport.update({
  id: "/admin/service-accounts",
  path: "/admin/service-accounts",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPoliciesRoute = AdminPoliciesRouteImport.update({
  id: "/admin/policies",
  path: "/admin/policies",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMigrateRoute = AdminMigrateRouteImport.update({
  id: "/admin/migrate",
  path: "/admin/migrate",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: "/admin/login",
  path: "/admin/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFirstRunRoute = AdminFirstRunRouteImport.update({
  id: "/admin/first-run",
  path: "/admin/first-run",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: "/admin/audit",
  path: "/admin/audit",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesWebhooksIndexRoute = FilesWebhooksIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FilesWebhooksRoute,
} as any)
const FilesSyncsIndexRoute = FilesSyncsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FilesSyncsRoute,
} as any)
const FilesSharesIndexRoute = FilesSharesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FilesSharesRoute,
} as any)
const FilesKeysIndexRoute = FilesKeysIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FilesKeysRoute,
} as any)
const FilesFederatedBucketsIndexRoute =
  FilesFederatedBucketsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => FilesFederatedBucketsRoute,
  } as any)
const FilesBackupsIndexRoute = FilesBackupsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FilesBackupsRoute,
} as any)
const FilesRegionIdIndexRoute = FilesRegionIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => FilesRegionIdRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminServiceAccountsIndexRoute =
  AdminServiceAccountsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AdminServiceAccountsRoute,
  } as any)
const AdminClustersIndexRoute = AdminClustersIndexRouteImport.update({
  id: "/admin/clusters/",
  path: "/admin/clusters/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBucketsIndexRoute = AdminBucketsIndexRouteImport.update({
  id: "/admin/buckets/",
  path: "/admin/buckets/",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesWebhooksNewRoute = FilesWebhooksNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => FilesWebhooksRoute,
} as any)
const FilesSyncsNewRoute = FilesSyncsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => FilesSyncsRoute,
} as any)
const FilesSharesNewRoute = FilesSharesNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => FilesSharesRoute,
} as any)
const FilesRegionsNewRoute = FilesRegionsNewRouteImport.update({
  id: "/files/regions/new",
  path: "/files/regions/new",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesKeysNewRoute = FilesKeysNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => FilesKeysRoute,
} as any)
const FilesFederatedBucketsNewRoute =
  FilesFederatedBucketsNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => FilesFederatedBucketsRoute,
  } as any)
const FilesBackupsNewRoute = FilesBackupsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => FilesBackupsRoute,
} as any)
const AdminUsersNewRoute = AdminUsersNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminServiceAccountsNewRoute = AdminServiceAccountsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AdminServiceAccountsRoute,
} as any)
const AdminServiceAccountsIdRoute = AdminServiceAccountsIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => AdminServiceAccountsRoute,
} as any)
const AdminClustersNewRoute = AdminClustersNewRouteImport.update({
  id: "/admin/clusters/new",
  path: "/admin/clusters/new",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesWebhooksIdIndexRoute = FilesWebhooksIdIndexRouteImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => FilesWebhooksRoute,
} as any)
const FilesFederatedBucketsIdIndexRoute =
  FilesFederatedBucketsIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => FilesFederatedBucketsRoute,
  } as any)
const FilesBackupsIdIndexRoute = FilesBackupsIdIndexRouteImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => FilesBackupsRoute,
} as any)
const AdminClustersCidIndexRoute = AdminClustersCidIndexRouteImport.update({
  id: "/admin/clusters/$cid/",
  path: "/admin/clusters/$cid/",
  getParentRoute: () => rootRouteImport,
} as any)
const FilesBackupsIdRestoreRoute = FilesBackupsIdRestoreRouteImport.update({
  id: "/$id/restore",
  path: "/$id/restore",
  getParentRoute: () => FilesBackupsRoute,
} as any)
const FilesRegionIdBBidRoute = FilesRegionIdBBidRouteImport.update({
  id: "/b/$bid",
  path: "/b/$bid",
  getParentRoute: () => FilesRegionIdRoute,
} as any)
const AdminClustersCidScrubRoute = AdminClustersCidScrubRouteImport.update({
  id: "/admin/clusters/$cid/scrub",
  path: "/admin/clusters/$cid/scrub",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClustersCidLayoutRoute = AdminClustersCidLayoutRouteImport.update({
  id: "/admin/clusters/$cid/layout",
  path: "/admin/clusters/$cid/layout",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClustersCidEditRoute = AdminClustersCidEditRouteImport.update({
  id: "/admin/clusters/$cid/edit",
  path: "/admin/clusters/$cid/edit",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClustersCidKeysIdRoute = AdminClustersCidKeysIdRouteImport.update({
  id: "/admin/clusters/$cid/keys/$id",
  path: "/admin/clusters/$cid/keys/$id",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClustersCidBucketsIdRoute =
  AdminClustersCidBucketsIdRouteImport.update({
    id: "/admin/clusters/$cid/buckets/$id",
    path: "/admin/clusters/$cid/buckets/$id",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminClustersCidBucketsIdLifecycleNewRoute =
  AdminClustersCidBucketsIdLifecycleNewRouteImport.update({
    id: "/lifecycle/new",
    path: "/lifecycle/new",
    getParentRoute: () => AdminClustersCidBucketsIdRoute,
  } as any)
const AdminClustersCidBucketsIdLifecycleRuleIdEditRoute =
  AdminClustersCidBucketsIdLifecycleRuleIdEditRouteImport.update({
    id: "/lifecycle/$ruleId/edit",
    path: "/lifecycle/$ruleId/edit",
    getParentRoute: () => AdminClustersCidBucketsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/signup": typeof SignupRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/first-run": typeof AdminFirstRunRoute
  "/admin/login": typeof AdminLoginRoute
  "/admin/migrate": typeof AdminMigrateRoute
  "/admin/policies": typeof AdminPoliciesRoute
  "/admin/service-accounts": typeof AdminServiceAccountsRouteWithChildren
  "/admin/system": typeof AdminSystemRoute
  "/admin/usage": typeof AdminUsageRoute
  "/admin/users": typeof AdminUsersRouteWithChildren
  "/files/$regionId": typeof FilesRegionIdRouteWithChildren
  "/files/backups": typeof FilesBackupsRouteWithChildren
  "/files/federated-buckets": typeof FilesFederatedBucketsRouteWithChildren
  "/files/keys": typeof FilesKeysRouteWithChildren
  "/files/shares": typeof FilesSharesRouteWithChildren
  "/files/syncs": typeof FilesSyncsRouteWithChildren
  "/files/webhooks": typeof FilesWebhooksRouteWithChildren
  "/share/$token": typeof ShareTokenRoute
  "/admin/": typeof AdminIndexRoute
  "/files/": typeof FilesIndexRoute
  "/admin/clusters/new": typeof AdminClustersNewRoute
  "/admin/service-accounts/$id": typeof AdminServiceAccountsIdRoute
  "/admin/service-accounts/new": typeof AdminServiceAccountsNewRoute
  "/admin/users/new": typeof AdminUsersNewRoute
  "/files/backups/new": typeof FilesBackupsNewRoute
  "/files/federated-buckets/new": typeof FilesFederatedBucketsNewRoute
  "/files/keys/new": typeof FilesKeysNewRoute
  "/files/regions/new": typeof FilesRegionsNewRoute
  "/files/shares/new": typeof FilesSharesNewRoute
  "/files/syncs/new": typeof FilesSyncsNewRoute
  "/files/webhooks/new": typeof FilesWebhooksNewRoute
  "/admin/buckets/": typeof AdminBucketsIndexRoute
  "/admin/clusters/": typeof AdminClustersIndexRoute
  "/admin/service-accounts/": typeof AdminServiceAccountsIndexRoute
  "/admin/users/": typeof AdminUsersIndexRoute
  "/files/$regionId/": typeof FilesRegionIdIndexRoute
  "/files/backups/": typeof FilesBackupsIndexRoute
  "/files/federated-buckets/": typeof FilesFederatedBucketsIndexRoute
  "/files/keys/": typeof FilesKeysIndexRoute
  "/files/shares/": typeof FilesSharesIndexRoute
  "/files/syncs/": typeof FilesSyncsIndexRoute
  "/files/webhooks/": typeof FilesWebhooksIndexRoute
  "/admin/clusters/$cid/edit": typeof AdminClustersCidEditRoute
  "/admin/clusters/$cid/layout": typeof AdminClustersCidLayoutRoute
  "/admin/clusters/$cid/scrub": typeof AdminClustersCidScrubRoute
  "/files/$regionId/b/$bid": typeof FilesRegionIdBBidRoute
  "/files/backups/$id/restore": typeof FilesBackupsIdRestoreRoute
  "/admin/clusters/$cid/": typeof AdminClustersCidIndexRoute
  "/files/backups/$id/": typeof FilesBackupsIdIndexRoute
  "/files/federated-buckets/$id/": typeof FilesFederatedBucketsIdIndexRoute
  "/files/webhooks/$id/": typeof FilesWebhooksIdIndexRoute
  "/admin/clusters/$cid/buckets/$id": typeof AdminClustersCidBucketsIdRouteWithChildren
  "/admin/clusters/$cid/keys/$id": typeof AdminClustersCidKeysIdRoute
  "/admin/clusters/$cid/buckets/$id/lifecycle/new": typeof AdminClustersCidBucketsIdLifecycleNewRoute
  "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit": typeof AdminClustersCidBucketsIdLifecycleRuleIdEditRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/signup": typeof SignupRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/first-run": typeof AdminFirstRunRoute
  "/admin/login": typeof AdminLoginRoute
  "/admin/migrate": typeof AdminMigrateRoute
  "/admin/policies": typeof AdminPoliciesRoute
  "/admin/system": typeof AdminSystemRoute
  "/admin/usage": typeof AdminUsageRoute
  "/share/$token": typeof ShareTokenRoute
  "/admin": typeof AdminIndexRoute
  "/files": typeof FilesIndexRoute
  "/admin/clusters/new": typeof AdminClustersNewRoute
  "/admin/service-accounts/$id": typeof AdminServiceAccountsIdRoute
  "/admin/service-accounts/new": typeof AdminServiceAccountsNewRoute
  "/admin/users/new": typeof AdminUsersNewRoute
  "/files/backups/new": typeof FilesBackupsNewRoute
  "/files/federated-buckets/new": typeof FilesFederatedBucketsNewRoute
  "/files/keys/new": typeof FilesKeysNewRoute
  "/files/regions/new": typeof FilesRegionsNewRoute
  "/files/shares/new": typeof FilesSharesNewRoute
  "/files/syncs/new": typeof FilesSyncsNewRoute
  "/files/webhooks/new": typeof FilesWebhooksNewRoute
  "/admin/buckets": typeof AdminBucketsIndexRoute
  "/admin/clusters": typeof AdminClustersIndexRoute
  "/admin/service-accounts": typeof AdminServiceAccountsIndexRoute
  "/admin/users": typeof AdminUsersIndexRoute
  "/files/$regionId": typeof FilesRegionIdIndexRoute
  "/files/backups": typeof FilesBackupsIndexRoute
  "/files/federated-buckets": typeof FilesFederatedBucketsIndexRoute
  "/files/keys": typeof FilesKeysIndexRoute
  "/files/shares": typeof FilesSharesIndexRoute
  "/files/syncs": typeof FilesSyncsIndexRoute
  "/files/webhooks": typeof FilesWebhooksIndexRoute
  "/admin/clusters/$cid/edit": typeof AdminClustersCidEditRoute
  "/admin/clusters/$cid/layout": typeof AdminClustersCidLayoutRoute
  "/admin/clusters/$cid/scrub": typeof AdminClustersCidScrubRoute
  "/files/$regionId/b/$bid": typeof FilesRegionIdBBidRoute
  "/files/backups/$id/restore": typeof FilesBackupsIdRestoreRoute
  "/admin/clusters/$cid": typeof AdminClustersCidIndexRoute
  "/files/backups/$id": typeof FilesBackupsIdIndexRoute
  "/files/federated-buckets/$id": typeof FilesFederatedBucketsIdIndexRoute
  "/files/webhooks/$id": typeof FilesWebhooksIdIndexRoute
  "/admin/clusters/$cid/buckets/$id": typeof AdminClustersCidBucketsIdRouteWithChildren
  "/admin/clusters/$cid/keys/$id": typeof AdminClustersCidKeysIdRoute
  "/admin/clusters/$cid/buckets/$id/lifecycle/new": typeof AdminClustersCidBucketsIdLifecycleNewRoute
  "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit": typeof AdminClustersCidBucketsIdLifecycleRuleIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/signup": typeof SignupRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/first-run": typeof AdminFirstRunRoute
  "/admin/login": typeof AdminLoginRoute
  "/admin/migrate": typeof AdminMigrateRoute
  "/admin/policies": typeof AdminPoliciesRoute
  "/admin/service-accounts": typeof AdminServiceAccountsRouteWithChildren
  "/admin/system": typeof AdminSystemRoute
  "/admin/usage": typeof AdminUsageRoute
  "/admin/users": typeof AdminUsersRouteWithChildren
  "/files/$regionId": typeof FilesRegionIdRouteWithChildren
  "/files/backups": typeof FilesBackupsRouteWithChildren
  "/files/federated-buckets": typeof FilesFederatedBucketsRouteWithChildren
  "/files/keys": typeof FilesKeysRouteWithChildren
  "/files/shares": typeof FilesSharesRouteWithChildren
  "/files/syncs": typeof FilesSyncsRouteWithChildren
  "/files/webhooks": typeof FilesWebhooksRouteWithChildren
  "/share/$token": typeof ShareTokenRoute
  "/admin/": typeof AdminIndexRoute
  "/files/": typeof FilesIndexRoute
  "/admin/clusters/new": typeof AdminClustersNewRoute
  "/admin/service-accounts/$id": typeof AdminServiceAccountsIdRoute
  "/admin/service-accounts/new": typeof AdminServiceAccountsNewRoute
  "/admin/users/new": typeof AdminUsersNewRoute
  "/files/backups/new": typeof FilesBackupsNewRoute
  "/files/federated-buckets/new": typeof FilesFederatedBucketsNewRoute
  "/files/keys/new": typeof FilesKeysNewRoute
  "/files/regions/new": typeof FilesRegionsNewRoute
  "/files/shares/new": typeof FilesSharesNewRoute
  "/files/syncs/new": typeof FilesSyncsNewRoute
  "/files/webhooks/new": typeof FilesWebhooksNewRoute
  "/admin/buckets/": typeof AdminBucketsIndexRoute
  "/admin/clusters/": typeof AdminClustersIndexRoute
  "/admin/service-accounts/": typeof AdminServiceAccountsIndexRoute
  "/admin/users/": typeof AdminUsersIndexRoute
  "/files/$regionId/": typeof FilesRegionIdIndexRoute
  "/files/backups/": typeof FilesBackupsIndexRoute
  "/files/federated-buckets/": typeof FilesFederatedBucketsIndexRoute
  "/files/keys/": typeof FilesKeysIndexRoute
  "/files/shares/": typeof FilesSharesIndexRoute
  "/files/syncs/": typeof FilesSyncsIndexRoute
  "/files/webhooks/": typeof FilesWebhooksIndexRoute
  "/admin/clusters/$cid/edit": typeof AdminClustersCidEditRoute
  "/admin/clusters/$cid/layout": typeof AdminClustersCidLayoutRoute
  "/admin/clusters/$cid/scrub": typeof AdminClustersCidScrubRoute
  "/files/$regionId/b/$bid": typeof FilesRegionIdBBidRoute
  "/files/backups/$id/restore": typeof FilesBackupsIdRestoreRoute
  "/admin/clusters/$cid/": typeof AdminClustersCidIndexRoute
  "/files/backups/$id/": typeof FilesBackupsIdIndexRoute
  "/files/federated-buckets/$id/": typeof FilesFederatedBucketsIdIndexRoute
  "/files/webhooks/$id/": typeof FilesWebhooksIdIndexRoute
  "/admin/clusters/$cid/buckets/$id": typeof AdminClustersCidBucketsIdRouteWithChildren
  "/admin/clusters/$cid/keys/$id": typeof AdminClustersCidKeysIdRoute
  "/admin/clusters/$cid/buckets/$id/lifecycle/new": typeof AdminClustersCidBucketsIdLifecycleNewRoute
  "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit": typeof AdminClustersCidBucketsIdLifecycleRuleIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/signup"
    | "/admin/audit"
    | "/admin/first-run"
    | "/admin/login"
    | "/admin/migrate"
    | "/admin/policies"
    | "/admin/service-accounts"
    | "/admin/system"
    | "/admin/usage"
    | "/admin/users"
    | "/files/$regionId"
    | "/files/backups"
    | "/files/federated-buckets"
    | "/files/keys"
    | "/files/shares"
    | "/files/syncs"
    | "/files/webhooks"
    | "/share/$token"
    | "/admin/"
    | "/files/"
    | "/admin/clusters/new"
    | "/admin/service-accounts/$id"
    | "/admin/service-accounts/new"
    | "/admin/users/new"
    | "/files/backups/new"
    | "/files/federated-buckets/new"
    | "/files/keys/new"
    | "/files/regions/new"
    | "/files/shares/new"
    | "/files/syncs/new"
    | "/files/webhooks/new"
    | "/admin/buckets/"
    | "/admin/clusters/"
    | "/admin/service-accounts/"
    | "/admin/users/"
    | "/files/$regionId/"
    | "/files/backups/"
    | "/files/federated-buckets/"
    | "/files/keys/"
    | "/files/shares/"
    | "/files/syncs/"
    | "/files/webhooks/"
    | "/admin/clusters/$cid/edit"
    | "/admin/clusters/$cid/layout"
    | "/admin/clusters/$cid/scrub"
    | "/files/$regionId/b/$bid"
    | "/files/backups/$id/restore"
    | "/admin/clusters/$cid/"
    | "/files/backups/$id/"
    | "/files/federated-buckets/$id/"
    | "/files/webhooks/$id/"
    | "/admin/clusters/$cid/buckets/$id"
    | "/admin/clusters/$cid/keys/$id"
    | "/admin/clusters/$cid/buckets/$id/lifecycle/new"
    | "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/login"
    | "/signup"
    | "/admin/audit"
    | "/admin/first-run"
    | "/admin/login"
    | "/admin/migrate"
    | "/admin/policies"
    | "/admin/system"
    | "/admin/usage"
    | "/share/$token"
    | "/admin"
    | "/files"
    | "/admin/clusters/new"
    | "/admin/service-accounts/$id"
    | "/admin/service-accounts/new"
    | "/admin/users/new"
    | "/files/backups/new"
    | "/files/federated-buckets/new"
    | "/files/keys/new"
    | "/files/regions/new"
    | "/files/shares/new"
    | "/files/syncs/new"
    | "/files/webhooks/new"
    | "/admin/buckets"
    | "/admin/clusters"
    | "/admin/service-accounts"
    | "/admin/users"
    | "/files/$regionId"
    | "/files/backups"
    | "/files/federated-buckets"
    | "/files/keys"
    | "/files/shares"
    | "/files/syncs"
    | "/files/webhooks"
    | "/admin/clusters/$cid/edit"
    | "/admin/clusters/$cid/layout"
    | "/admin/clusters/$cid/scrub"
    | "/files/$regionId/b/$bid"
    | "/files/backups/$id/restore"
    | "/admin/clusters/$cid"
    | "/files/backups/$id"
    | "/files/federated-buckets/$id"
    | "/files/webhooks/$id"
    | "/admin/clusters/$cid/buckets/$id"
    | "/admin/clusters/$cid/keys/$id"
    | "/admin/clusters/$cid/buckets/$id/lifecycle/new"
    | "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit"
  id:
    | "__root__"
    | "/"
    | "/login"
    | "/signup"
    | "/admin/audit"
    | "/admin/first-run"
    | "/admin/login"
    | "/admin/migrate"
    | "/admin/policies"
    | "/admin/service-accounts"
    | "/admin/system"
    | "/admin/usage"
    | "/admin/users"
    | "/files/$regionId"
    | "/files/backups"
    | "/files/federated-buckets"
    | "/files/keys"
    | "/files/shares"
    | "/files/syncs"
    | "/files/webhooks"
    | "/share/$token"
    | "/admin/"
    | "/files/"
    | "/admin/clusters/new"
    | "/admin/service-accounts/$id"
    | "/admin/service-accounts/new"
    | "/admin/users/new"
    | "/files/backups/new"
    | "/files/federated-buckets/new"
    | "/files/keys/new"
    | "/files/regions/new"
    | "/files/shares/new"
    | "/files/syncs/new"
    | "/files/webhooks/new"
    | "/admin/buckets/"
    | "/admin/clusters/"
    | "/admin/service-accounts/"
    | "/admin/users/"
    | "/files/$regionId/"
    | "/files/backups/"
    | "/files/federated-buckets/"
    | "/files/keys/"
    | "/files/shares/"
    | "/files/syncs/"
    | "/files/webhooks/"
    | "/admin/clusters/$cid/edit"
    | "/admin/clusters/$cid/layout"
    | "/admin/clusters/$cid/scrub"
    | "/files/$regionId/b/$bid"
    | "/files/backups/$id/restore"
    | "/admin/clusters/$cid/"
    | "/files/backups/$id/"
    | "/files/federated-buckets/$id/"
    | "/files/webhooks/$id/"
    | "/admin/clusters/$cid/buckets/$id"
    | "/admin/clusters/$cid/keys/$id"
    | "/admin/clusters/$cid/buckets/$id/lifecycle/new"
    | "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminFirstRunRoute: typeof AdminFirstRunRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMigrateRoute: typeof AdminMigrateRoute
  AdminPoliciesRoute: typeof AdminPoliciesRoute
  AdminServiceAccountsRoute: typeof AdminServiceAccountsRouteWithChildren
  AdminSystemRoute: typeof AdminSystemRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  FilesRegionIdRoute: typeof FilesRegionIdRouteWithChildren
  FilesBackupsRoute: typeof FilesBackupsRouteWithChildren
  FilesFederatedBucketsRoute: typeof FilesFederatedBucketsRouteWithChildren
  FilesKeysRoute: typeof FilesKeysRouteWithChildren
  FilesSharesRoute: typeof FilesSharesRouteWithChildren
  FilesSyncsRoute: typeof FilesSyncsRouteWithChildren
  FilesWebhooksRoute: typeof FilesWebhooksRouteWithChildren
  ShareTokenRoute: typeof ShareTokenRoute
  AdminIndexRoute: typeof AdminIndexRoute
  FilesIndexRoute: typeof FilesIndexRoute
  AdminClustersNewRoute: typeof AdminClustersNewRoute
  FilesRegionsNewRoute: typeof FilesRegionsNewRoute
  AdminBucketsIndexRoute: typeof AdminBucketsIndexRoute
  AdminClustersIndexRoute: typeof AdminClustersIndexRoute
  AdminClustersCidEditRoute: typeof AdminClustersCidEditRoute
  AdminClustersCidLayoutRoute: typeof AdminClustersCidLayoutRoute
  AdminClustersCidScrubRoute: typeof AdminClustersCidScrubRoute
  AdminClustersCidIndexRoute: typeof AdminClustersCidIndexRoute
  AdminClustersCidBucketsIdRoute: typeof AdminClustersCidBucketsIdRouteWithChildren
  AdminClustersCidKeysIdRoute: typeof AdminClustersCidKeysIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/signup": {
      id: "/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/": {
      id: "/files/"
      path: "/files"
      fullPath: "/files/"
      preLoaderRoute: typeof FilesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/": {
      id: "/admin/"
      path: "/admin"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/share/$token": {
      id: "/share/$token"
      path: "/share/$token"
      fullPath: "/share/$token"
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/webhooks": {
      id: "/files/webhooks"
      path: "/files/webhooks"
      fullPath: "/files/webhooks"
      preLoaderRoute: typeof FilesWebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/syncs": {
      id: "/files/syncs"
      path: "/files/syncs"
      fullPath: "/files/syncs"
      preLoaderRoute: typeof FilesSyncsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/shares": {
      id: "/files/shares"
      path: "/files/shares"
      fullPath: "/files/shares"
      preLoaderRoute: typeof FilesSharesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/keys": {
      id: "/files/keys"
      path: "/files/keys"
      fullPath: "/files/keys"
      preLoaderRoute: typeof FilesKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/federated-buckets": {
      id: "/files/federated-buckets"
      path: "/files/federated-buckets"
      fullPath: "/files/federated-buckets"
      preLoaderRoute: typeof FilesFederatedBucketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/backups": {
      id: "/files/backups"
      path: "/files/backups"
      fullPath: "/files/backups"
      preLoaderRoute: typeof FilesBackupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/$regionId": {
      id: "/files/$regionId"
      path: "/files/$regionId"
      fullPath: "/files/$regionId"
      preLoaderRoute: typeof FilesRegionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/users": {
      id: "/admin/users"
      path: "/admin/users"
      fullPath: "/admin/users"
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/usage": {
      id: "/admin/usage"
      path: "/admin/usage"
      fullPath: "/admin/usage"
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/system": {
      id: "/admin/system"
      path: "/admin/system"
      fullPath: "/admin/system"
      preLoaderRoute: typeof AdminSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/service-accounts": {
      id: "/admin/service-accounts"
      path: "/admin/service-accounts"
      fullPath: "/admin/service-accounts"
      preLoaderRoute: typeof AdminServiceAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/policies": {
      id: "/admin/policies"
      path: "/admin/policies"
      fullPath: "/admin/policies"
      preLoaderRoute: typeof AdminPoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/migrate": {
      id: "/admin/migrate"
      path: "/admin/migrate"
      fullPath: "/admin/migrate"
      preLoaderRoute: typeof AdminMigrateRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/login": {
      id: "/admin/login"
      path: "/admin/login"
      fullPath: "/admin/login"
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/first-run": {
      id: "/admin/first-run"
      path: "/admin/first-run"
      fullPath: "/admin/first-run"
      preLoaderRoute: typeof AdminFirstRunRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/audit": {
      id: "/admin/audit"
      path: "/admin/audit"
      fullPath: "/admin/audit"
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/webhooks/": {
      id: "/files/webhooks/"
      path: "/"
      fullPath: "/files/webhooks/"
      preLoaderRoute: typeof FilesWebhooksIndexRouteImport
      parentRoute: typeof FilesWebhooksRoute
    }
    "/files/syncs/": {
      id: "/files/syncs/"
      path: "/"
      fullPath: "/files/syncs/"
      preLoaderRoute: typeof FilesSyncsIndexRouteImport
      parentRoute: typeof FilesSyncsRoute
    }
    "/files/shares/": {
      id: "/files/shares/"
      path: "/"
      fullPath: "/files/shares/"
      preLoaderRoute: typeof FilesSharesIndexRouteImport
      parentRoute: typeof FilesSharesRoute
    }
    "/files/keys/": {
      id: "/files/keys/"
      path: "/"
      fullPath: "/files/keys/"
      preLoaderRoute: typeof FilesKeysIndexRouteImport
      parentRoute: typeof FilesKeysRoute
    }
    "/files/federated-buckets/": {
      id: "/files/federated-buckets/"
      path: "/"
      fullPath: "/files/federated-buckets/"
      preLoaderRoute: typeof FilesFederatedBucketsIndexRouteImport
      parentRoute: typeof FilesFederatedBucketsRoute
    }
    "/files/backups/": {
      id: "/files/backups/"
      path: "/"
      fullPath: "/files/backups/"
      preLoaderRoute: typeof FilesBackupsIndexRouteImport
      parentRoute: typeof FilesBackupsRoute
    }
    "/files/$regionId/": {
      id: "/files/$regionId/"
      path: "/"
      fullPath: "/files/$regionId/"
      preLoaderRoute: typeof FilesRegionIdIndexRouteImport
      parentRoute: typeof FilesRegionIdRoute
    }
    "/admin/users/": {
      id: "/admin/users/"
      path: "/"
      fullPath: "/admin/users/"
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    "/admin/service-accounts/": {
      id: "/admin/service-accounts/"
      path: "/"
      fullPath: "/admin/service-accounts/"
      preLoaderRoute: typeof AdminServiceAccountsIndexRouteImport
      parentRoute: typeof AdminServiceAccountsRoute
    }
    "/admin/clusters/": {
      id: "/admin/clusters/"
      path: "/admin/clusters"
      fullPath: "/admin/clusters/"
      preLoaderRoute: typeof AdminClustersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/buckets/": {
      id: "/admin/buckets/"
      path: "/admin/buckets"
      fullPath: "/admin/buckets/"
      preLoaderRoute: typeof AdminBucketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/webhooks/new": {
      id: "/files/webhooks/new"
      path: "/new"
      fullPath: "/files/webhooks/new"
      preLoaderRoute: typeof FilesWebhooksNewRouteImport
      parentRoute: typeof FilesWebhooksRoute
    }
    "/files/syncs/new": {
      id: "/files/syncs/new"
      path: "/new"
      fullPath: "/files/syncs/new"
      preLoaderRoute: typeof FilesSyncsNewRouteImport
      parentRoute: typeof FilesSyncsRoute
    }
    "/files/shares/new": {
      id: "/files/shares/new"
      path: "/new"
      fullPath: "/files/shares/new"
      preLoaderRoute: typeof FilesSharesNewRouteImport
      parentRoute: typeof FilesSharesRoute
    }
    "/files/regions/new": {
      id: "/files/regions/new"
      path: "/files/regions/new"
      fullPath: "/files/regions/new"
      preLoaderRoute: typeof FilesRegionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/keys/new": {
      id: "/files/keys/new"
      path: "/new"
      fullPath: "/files/keys/new"
      preLoaderRoute: typeof FilesKeysNewRouteImport
      parentRoute: typeof FilesKeysRoute
    }
    "/files/federated-buckets/new": {
      id: "/files/federated-buckets/new"
      path: "/new"
      fullPath: "/files/federated-buckets/new"
      preLoaderRoute: typeof FilesFederatedBucketsNewRouteImport
      parentRoute: typeof FilesFederatedBucketsRoute
    }
    "/files/backups/new": {
      id: "/files/backups/new"
      path: "/new"
      fullPath: "/files/backups/new"
      preLoaderRoute: typeof FilesBackupsNewRouteImport
      parentRoute: typeof FilesBackupsRoute
    }
    "/admin/users/new": {
      id: "/admin/users/new"
      path: "/new"
      fullPath: "/admin/users/new"
      preLoaderRoute: typeof AdminUsersNewRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    "/admin/service-accounts/new": {
      id: "/admin/service-accounts/new"
      path: "/new"
      fullPath: "/admin/service-accounts/new"
      preLoaderRoute: typeof AdminServiceAccountsNewRouteImport
      parentRoute: typeof AdminServiceAccountsRoute
    }
    "/admin/service-accounts/$id": {
      id: "/admin/service-accounts/$id"
      path: "/$id"
      fullPath: "/admin/service-accounts/$id"
      preLoaderRoute: typeof AdminServiceAccountsIdRouteImport
      parentRoute: typeof AdminServiceAccountsRoute
    }
    "/admin/clusters/new": {
      id: "/admin/clusters/new"
      path: "/admin/clusters/new"
      fullPath: "/admin/clusters/new"
      preLoaderRoute: typeof AdminClustersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/webhooks/$id/": {
      id: "/files/webhooks/$id/"
      path: "/$id"
      fullPath: "/files/webhooks/$id/"
      preLoaderRoute: typeof FilesWebhooksIdIndexRouteImport
      parentRoute: typeof FilesWebhooksRoute
    }
    "/files/federated-buckets/$id/": {
      id: "/files/federated-buckets/$id/"
      path: "/$id"
      fullPath: "/files/federated-buckets/$id/"
      preLoaderRoute: typeof FilesFederatedBucketsIdIndexRouteImport
      parentRoute: typeof FilesFederatedBucketsRoute
    }
    "/files/backups/$id/": {
      id: "/files/backups/$id/"
      path: "/$id"
      fullPath: "/files/backups/$id/"
      preLoaderRoute: typeof FilesBackupsIdIndexRouteImport
      parentRoute: typeof FilesBackupsRoute
    }
    "/admin/clusters/$cid/": {
      id: "/admin/clusters/$cid/"
      path: "/admin/clusters/$cid"
      fullPath: "/admin/clusters/$cid/"
      preLoaderRoute: typeof AdminClustersCidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/files/backups/$id/restore": {
      id: "/files/backups/$id/restore"
      path: "/$id/restore"
      fullPath: "/files/backups/$id/restore"
      preLoaderRoute: typeof FilesBackupsIdRestoreRouteImport
      parentRoute: typeof FilesBackupsRoute
    }
    "/files/$regionId/b/$bid": {
      id: "/files/$regionId/b/$bid"
      path: "/b/$bid"
      fullPath: "/files/$regionId/b/$bid"
      preLoaderRoute: typeof FilesRegionIdBBidRouteImport
      parentRoute: typeof FilesRegionIdRoute
    }
    "/admin/clusters/$cid/scrub": {
      id: "/admin/clusters/$cid/scrub"
      path: "/admin/clusters/$cid/scrub"
      fullPath: "/admin/clusters/$cid/scrub"
      preLoaderRoute: typeof AdminClustersCidScrubRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/clusters/$cid/layout": {
      id: "/admin/clusters/$cid/layout"
      path: "/admin/clusters/$cid/layout"
      fullPath: "/admin/clusters/$cid/layout"
      preLoaderRoute: typeof AdminClustersCidLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/clusters/$cid/edit": {
      id: "/admin/clusters/$cid/edit"
      path: "/admin/clusters/$cid/edit"
      fullPath: "/admin/clusters/$cid/edit"
      preLoaderRoute: typeof AdminClustersCidEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/clusters/$cid/keys/$id": {
      id: "/admin/clusters/$cid/keys/$id"
      path: "/admin/clusters/$cid/keys/$id"
      fullPath: "/admin/clusters/$cid/keys/$id"
      preLoaderRoute: typeof AdminClustersCidKeysIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/clusters/$cid/buckets/$id": {
      id: "/admin/clusters/$cid/buckets/$id"
      path: "/admin/clusters/$cid/buckets/$id"
      fullPath: "/admin/clusters/$cid/buckets/$id"
      preLoaderRoute: typeof AdminClustersCidBucketsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/clusters/$cid/buckets/$id/lifecycle/new": {
      id: "/admin/clusters/$cid/buckets/$id/lifecycle/new"
      path: "/lifecycle/new"
      fullPath: "/admin/clusters/$cid/buckets/$id/lifecycle/new"
      preLoaderRoute: typeof AdminClustersCidBucketsIdLifecycleNewRouteImport
      parentRoute: typeof AdminClustersCidBucketsIdRoute
    }
    "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit": {
      id: "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit"
      path: "/lifecycle/$ruleId/edit"
      fullPath: "/admin/clusters/$cid/buckets/$id/lifecycle/$ruleId/edit"
      preLoaderRoute: typeof AdminClustersCidBucketsIdLifecycleRuleIdEditRouteImport
      parentRoute: typeof AdminClustersCidBucketsIdRoute
    }
  }
}

interface AdminServiceAccountsRouteChildren {
  AdminServiceAccountsIdRoute: typeof AdminServiceAccountsIdRoute
  AdminServiceAccountsNewRoute: typeof AdminServiceAccountsNewRoute
  AdminServiceAccountsIndexRoute: typeof AdminServiceAccountsIndexRoute
}

const AdminServiceAccountsRouteChildren: AdminServiceAccountsRouteChildren = {
  AdminServiceAccountsIdRoute: AdminServiceAccountsIdRoute,
  AdminServiceAccountsNewRoute: AdminServiceAccountsNewRoute,
  AdminServiceAccountsIndexRoute: AdminServiceAccountsIndexRoute,
}

const AdminServiceAccountsRouteWithChildren =
  AdminServiceAccountsRoute._addFileChildren(AdminServiceAccountsRouteChildren)

interface AdminUsersRouteChildren {
  AdminUsersNewRoute: typeof AdminUsersNewRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersNewRoute: AdminUsersNewRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface FilesRegionIdRouteChildren {
  FilesRegionIdIndexRoute: typeof FilesRegionIdIndexRoute
  FilesRegionIdBBidRoute: typeof FilesRegionIdBBidRoute
}

const FilesRegionIdRouteChildren: FilesRegionIdRouteChildren = {
  FilesRegionIdIndexRoute: FilesRegionIdIndexRoute,
  FilesRegionIdBBidRoute: FilesRegionIdBBidRoute,
}

const FilesRegionIdRouteWithChildren = FilesRegionIdRoute._addFileChildren(
  FilesRegionIdRouteChildren,
)

interface FilesBackupsRouteChildren {
  FilesBackupsNewRoute: typeof FilesBackupsNewRoute
  FilesBackupsIndexRoute: typeof FilesBackupsIndexRoute
  FilesBackupsIdRestoreRoute: typeof FilesBackupsIdRestoreRoute
  FilesBackupsIdIndexRoute: typeof FilesBackupsIdIndexRoute
}

const FilesBackupsRouteChildren: FilesBackupsRouteChildren = {
  FilesBackupsNewRoute: FilesBackupsNewRoute,
  FilesBackupsIndexRoute: FilesBackupsIndexRoute,
  FilesBackupsIdRestoreRoute: FilesBackupsIdRestoreRoute,
  FilesBackupsIdIndexRoute: FilesBackupsIdIndexRoute,
}

const FilesBackupsRouteWithChildren = FilesBackupsRoute._addFileChildren(
  FilesBackupsRouteChildren,
)

interface FilesFederatedBucketsRouteChildren {
  FilesFederatedBucketsNewRoute: typeof FilesFederatedBucketsNewRoute
  FilesFederatedBucketsIndexRoute: typeof FilesFederatedBucketsIndexRoute
  FilesFederatedBucketsIdIndexRoute: typeof FilesFederatedBucketsIdIndexRoute
}

const FilesFederatedBucketsRouteChildren: FilesFederatedBucketsRouteChildren = {
  FilesFederatedBucketsNewRoute: FilesFederatedBucketsNewRoute,
  FilesFederatedBucketsIndexRoute: FilesFederatedBucketsIndexRoute,
  FilesFederatedBucketsIdIndexRoute: FilesFederatedBucketsIdIndexRoute,
}

const FilesFederatedBucketsRouteWithChildren =
  FilesFederatedBucketsRoute._addFileChildren(
    FilesFederatedBucketsRouteChildren,
  )

interface FilesKeysRouteChildren {
  FilesKeysNewRoute: typeof FilesKeysNewRoute
  FilesKeysIndexRoute: typeof FilesKeysIndexRoute
}

const FilesKeysRouteChildren: FilesKeysRouteChildren = {
  FilesKeysNewRoute: FilesKeysNewRoute,
  FilesKeysIndexRoute: FilesKeysIndexRoute,
}

const FilesKeysRouteWithChildren = FilesKeysRoute._addFileChildren(
  FilesKeysRouteChildren,
)

interface FilesSharesRouteChildren {
  FilesSharesNewRoute: typeof FilesSharesNewRoute
  FilesSharesIndexRoute: typeof FilesSharesIndexRoute
}

const FilesSharesRouteChildren: FilesSharesRouteChildren = {
  FilesSharesNewRoute: FilesSharesNewRoute,
  FilesSharesIndexRoute: FilesSharesIndexRoute,
}

const FilesSharesRouteWithChildren = FilesSharesRoute._addFileChildren(
  FilesSharesRouteChildren,
)

interface FilesSyncsRouteChildren {
  FilesSyncsNewRoute: typeof FilesSyncsNewRoute
  FilesSyncsIndexRoute: typeof FilesSyncsIndexRoute
}

const FilesSyncsRouteChildren: FilesSyncsRouteChildren = {
  FilesSyncsNewRoute: FilesSyncsNewRoute,
  FilesSyncsIndexRoute: FilesSyncsIndexRoute,
}

const FilesSyncsRouteWithChildren = FilesSyncsRoute._addFileChildren(
  FilesSyncsRouteChildren,
)

interface FilesWebhooksRouteChildren {
  FilesWebhooksNewRoute: typeof FilesWebhooksNewRoute
  FilesWebhooksIndexRoute: typeof FilesWebhooksIndexRoute
  FilesWebhooksIdIndexRoute: typeof FilesWebhooksIdIndexRoute
}

const FilesWebhooksRouteChildren: FilesWebhooksRouteChildren = {
  FilesWebhooksNewRoute: FilesWebhooksNewRoute,
  FilesWebhooksIndexRoute: FilesWebhooksIndexRoute,
  FilesWebhooksIdIndexRoute: FilesWebhooksIdIndexRoute,
}

const FilesWebhooksRouteWithChildren = FilesWebhooksRoute._addFileChildren(
  FilesWebhooksRouteChildren,
)

interface AdminClustersCidBucketsIdRouteChildren {
  AdminClustersCidBucketsIdLifecycleNewRoute: typeof AdminClustersCidBucketsIdLifecycleNewRoute
  AdminClustersCidBucketsIdLifecycleRuleIdEditRoute: typeof AdminClustersCidBucketsIdLifecycleRuleIdEditRoute
}

const AdminClustersCidBucketsIdRouteChildren: AdminClustersCidBucketsIdRouteChildren =
  {
    AdminClustersCidBucketsIdLifecycleNewRoute:
      AdminClustersCidBucketsIdLifecycleNewRoute,
    AdminClustersCidBucketsIdLifecycleRuleIdEditRoute:
      AdminClustersCidBucketsIdLifecycleRuleIdEditRoute,
  }

const AdminClustersCidBucketsIdRouteWithChildren =
  AdminClustersCidBucketsIdRoute._addFileChildren(
    AdminClustersCidBucketsIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminFirstRunRoute: AdminFirstRunRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMigrateRoute: AdminMigrateRoute,
  AdminPoliciesRoute: AdminPoliciesRoute,
  AdminServiceAccountsRoute: AdminServiceAccountsRouteWithChildren,
  AdminSystemRoute: AdminSystemRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  FilesRegionIdRoute: FilesRegionIdRouteWithChildren,
  FilesBackupsRoute: FilesBackupsRouteWithChildren,
  FilesFederatedBucketsRoute: FilesFederatedBucketsRouteWithChildren,
  FilesKeysRoute: FilesKeysRouteWithChildren,
  FilesSharesRoute: FilesSharesRouteWithChildren,
  FilesSyncsRoute: FilesSyncsRouteWithChildren,
  FilesWebhooksRoute: FilesWebhooksRouteWithChildren,
  ShareTokenRoute: ShareTokenRoute,
  AdminIndexRoute: AdminIndexRoute,
  FilesIndexRoute: FilesIndexRoute,
  AdminClustersNewRoute: AdminClustersNewRoute,
  FilesRegionsNewRoute: FilesRegionsNewRoute,
  AdminBucketsIndexRoute: AdminBucketsIndexRoute,
  AdminClustersIndexRoute: AdminClustersIndexRoute,
  AdminClustersCidEditRoute: AdminClustersCidEditRoute,
  AdminClustersCidLayoutRoute: AdminClustersCidLayoutRoute,
  AdminClustersCidScrubRoute: AdminClustersCidScrubRoute,
  AdminClustersCidIndexRoute: AdminClustersCidIndexRoute,
  AdminClustersCidBucketsIdRoute: AdminClustersCidBucketsIdRouteWithChildren,
  AdminClustersCidKeysIdRoute: AdminClustersCidKeysIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
